<template>
  <div>
    <div class="form-all">
      <div class="win">
        <slot name="title"></slot>
        <div class="form">
          <section class="form-main" ref="form">
            <!-- 姓名 -->
            <div v-for="(item, index) in [formConfig['name']]" :key="`name-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input slot="input" class="text-input" type="text" placeholder="请输入姓名" v-model="formData[item.key]"
                  @focus="focusItem(item)" @blur="blurItem(item)" />
              </form-item>
            </div>
            <!-- 性别&生日 -->
            <div class="field-gender">
              <div v-for="(item, index) in [formConfig['gender']]" class="tgo-gender" :key="`tg-${index}`">
                <form-item :item="item" :haveBorder="false" :ref="item.key" @setOKList="setOKList">
                  <tgo-radio slot="input" :labels="item.labels" :tkey="item.key" :value="formData[item.key]"
                    @input="getValue" @focus="focusInput(item)" @blur="blurItem(item)">
                  </tgo-radio>
                </form-item>
              </div>
            </div>
            <!-- 手机号 -->
            <form-item :item="formPhone" :haveBorder="false" :iview="true">
              <account-phone slot="input" ref="account"></account-phone>
            </form-item>
            <!-- e-mail -->
            <div v-for="(item, index) in [formConfig['email']]" :key="`e-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input slot="input" class="text-input" placeholder="请输入邮箱" type="text" v-model="formData[item.key]"
                  @focus="focusItem(item)" @blur="blurItem(item)" />
              </form-item>
            </div>
            <!-- 微信号 -->
            <div v-for="(item, index) in [formConfig['wechat']]" :key="`wechat-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input class="text-input" slot="input" :tkey="item.key" v-model="formData[item.key]" placeholder="请输入微信号"
                  @focus="focusItem(item)" @blur="blurItem(item)" />
              </form-item>
            </div>
            <!-- 个人专注领域 -->
            <div v-for="(item, index) in [formConfig['focus_areas_tags']]" :key="`fat-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList" :iview="true">
                <auto-match-input slot="input" dataSource="ajax" :types="tagTypes" :tkey="item.key"
                  placeholder="请输入关键词，如无匹配领域，请选择其他。" @setSelectedTypes="getValue" @searchKey="debounceSearchTags"
                  @focus="focusItem(item)" @blur="blurItem(item)"></auto-match-input>
              </form-item>
            </div>
            <!-- 期望加入的分会 -->
            <div v-for="(item, index) in [formConfig['expect_to_join']]" :key="`etj-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false">
                <tgo-select slot="input" :tkey="item.key" :selects="branchAll" @input="getValue" @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <div v-for="(item, index) in [formConfig['referrers']]" :key="`ref-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList" :iview="true">
                <auto-match-input slot="input" dataSource="ajax" :types="refererArr" :tkey="item.key"
                  placeholder="请填写推荐人姓名，若无推荐人此项可不填写" :singleSelect="true" :allowCustom="true" @setSelectedTypes="getValue"
                  @searchKey="debounceSearchReferer" @focus="focusItem(item)" @blur="blurItem(item)" :formatName="formatName"></auto-match-input>
              </form-item>
            </div>

            <!-- ===== 就业及教育经历部分 ===== -->
            <!-- 所在城市 -->
            <tgo-city @exportValue="getValue" :regCity="regCity" ref="tgoCity" @setRegCity="setRegCity"></tgo-city>
            <!-- 所在企业 -->
            <div v-for="(item, index) in [formConfig['company']]" :key="`c-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input
                slot="input"
                class="text-input"
                placeholder="请输入所在企业"
                type="text"
                v-model="formData[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
              </form-item>
            </div>
            <!-- 职位 -->
            <div v-for="(item, index) in [formConfig['job_title']]" :key="`j-${index}`">
              <form-item :item="item" :haveBorder="false" :iview="true" :ref="item.key" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="jobTitles"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <div v-if="formData['job_title'] === '12'">
              <div v-for="(item, index) in [formConfig['job_title_content']]" :key="`jt-${index}`" class="job-title-content">
                <span>{{item.subName}}</span>
                <form-item :item="item" :ref="item.key" @setOKList="setOKList" class="jtc-wrap">
                  <input
                  slot="input"
                  class="text-input"
                  placeholder="请输入职位名称"
                  type="text"
                  v-model="formData[item.key]"
                  @focus="focusItem(item)"
                  @blur="blurItem(item)">
                </form-item>
              </div>
            </div>
            <!-- 行业领域 -->
            <div v-for="(item, index) in [formConfig['company_industry']]" :key="`ci-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :multiple="true"
                :selects="companyIndustrys"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 融资阶段 -->
            <div v-for="(item, index) in [formConfig['company_type']]" :key="`ct-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="companyTypes"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 企业规模人数 -->
            <div class="company-scale">
              <div v-for="(item, index) in [formConfig['company_scale']]" :key="`cs-${index}`" class="scale">
                <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                  <tgo-select
                  slot="input"
                  :tkey="item.key"
                  :selects="companyScales"
                  @input="getValue"
                  @blur="blurItem(item)">
                  </tgo-select>
                </form-item>
              </div>
              <div v-for="(item, index) in [formConfig['company_remark']]" :key="`cr-${index}`" class="remark">
                <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                  <input
                  slot="input"
                  class="text-input"
                  placeholder="如：年收入5亿元，上轮融资13亿元"
                  type="text"
                  v-model="formData[item.key]"
                  @focus="focusItem(item)"
                  @blur="blurItem(item)">
                </form-item>
              </div>
            </div>
            <!-- 企业研发团队规模人数 -->
            <div v-for="(item, index) in [formConfig['company_develop']]" :key="`cd-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="companyDevelops"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 本人现带领团队规模人数 -->
            <div v-for="(item, index) in [formConfig['managed_team_size']]" :key="`mts-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="managedTeamSizes"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 本人曾带领团队最大规模（人数） -->
            <div v-for="(item, index) in [formConfig['development_team_size']]" :key="`dts-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="managedTeamSizes"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 从事研发工作起始年 -->
            <div v-for="(item, index) in [formConfig['developed_start_year']]" :key="`dsy-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <DatePicker
                slot="input"
                type="year"
                :tKey="item.key"
                placeholder="请选择"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></DatePicker>
              </form-item>
            </div>
            <!-- 从事管理工作起始年 -->
            <div v-for="(item, index) in [formConfig['managed_start_year']]" :key="`msy-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <DatePicker
                slot="input"
                type="year"
                :tKey="item.key"
                placeholder="请选择"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></DatePicker>
              </form-item>
            </div>
            <!-- 工作经历 -->
            <div v-for="(item, index) in [formConfig['work_experience']]" :key="`we-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input work-experience-input"
                :placeholder="item.placeholder"
                type="text"
                v-model="formData[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 职业成就 -->
            <div v-for="(item, index) in [formConfig['achievements']]" :key="`A-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input achievements-input"
                :placeholder="item.placeholder"
                type="text"
                v-model="formData[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 教育经历 -->
            <div v-for="(item, index) in [formConfig['study_experience']]" :key="`se-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input study-experience-input"
                :placeholder="item.placeholder"
                type="text"
                v-model="formData[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 可提供资源 -->
            <div v-for="(item, index) in [formConfig['support_resource']]" :key="`sr-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="您愿意为其他学员提供哪些资源？例如：技术管理话题分享，九折购买本公司云服务、融资创业专业渠道与建议等。"
                type="text"
                v-model="formData[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 期望获得的价值 -->
            <div v-for="(item, index) in [formConfig['want_resource']]" :key="`wt-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="您希望通过 TGO 获得什么？例如：交流分享管理技术，学习软技能，拓展人脉等。请您尽量详细填写您的诉求"
                type="text"
                v-model="formData[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 是否愿意参与、组织学员交流活动 -->
            <div v-for="(item, index) in [formConfig['willingness_to_participate']]" :key="`wtp-${index}`">
              <form-item :item="item" :ref="item.key" :haveBorder="false" @setOKList="setOKList">
                <div slot="extra2" class="subTitle">{{item.subTitle}}</div>
                <tgo-checkbox
                  slot="input"
                  :labels="item.labels"
                  :tkey="item.key"
                  :value="[1, 2]"
                  @input="getValue"
                  @focus="focusInput(item)"
                  @blur="blurItem(item)">
                </tgo-checkbox>
              </form-item>
            </div>

            <div class="submit">
              <div class="input" @click="submit">
                <span>提交申请</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/service'
import formItem from '@/components/form/form.item'
import { autoMatchInput } from '@/components/auto-match'
import tgoRadio from '@/components/form/radio'
import tgoSelect from '@/components/form/select'
import tgoCity from '../form-detail/linkSelect'
import tgoCheckbox from '@/components/form/checkbox'
import DatePicker from '@/components/form/date-picker'
import lodash from 'lodash'
import AccountPhone from '../form-info/AccountPhone'

import utils from '@/util'

// static 数据
import { getBranchAll } from '@/util/methods.js'
import { jobTitles, companyIndustrys, companyTypes, companyScales, companyDevelops, teamSizes as managedTeamSizes } from '@/data/form'

// 导入配置文件
import infoConfig from '../form-info/info-config'
import detailConfig from '../../account/my-info/user-edu/info-config'

export default {
  data () {
    return {
      formConfig: {
      },
      formData: {},
      warn: {},
      tagTypes: [],
      refererArr: [],
      tagsMapId: {},
      wechat: '',
      sameWithPhone: false,
      branchAll: [],
      regCity: true,
      remainNumber: {},
      // phone
      formPhone: {
        key: 'phone',
        name: '手机号',
        required: true
      },
      // 静态数据引入
      jobTitles,
      companyIndustrys,
      companyTypes,
      companyScales,
      companyDevelops,
      managedTeamSizes
    }
  },
  components: {
    formItem,
    autoMatchInput,
    tgoRadio,
    tgoSelect,
    tgoCity,
    tgoCheckbox,
    DatePicker,
    AccountPhone
  },
  created () {
    this.debounceSearchTags = lodash.debounce(this.SearchTags, 500)
    this.debounceSearchReferer = lodash.debounce(this.SearchReferer, 500)

    // 获取用户配置信息
    this.loadFormConfig()

    // get 分会数据
    getBranchAll()
      .then(data => { this.branchAll = data })
      .catch(err => { console.log(err) })
  },
  methods: {
    loadFormConfig () {
      // 合并基本信息和详细信息的配置
      this.formConfig = {
        ...infoConfig,
        ...detailConfig,
        // 添加意愿参与配置
        'willingness_to_participate': {
          'key': 'willingness_to_participate',
          'name': '是否愿意参与、组织学员交流活动',
          'subTitle': 'TGO 鲲鹏会是学员共建组织，"投入越多，收获越多"我们希望所有学员能够参与其中',
          'type': 'checkbox',
          'required': true,
          'labels': [
            { 'id': 'w1', 'value': 1, 'name': '愿意参与小组活动（约4小时／每月）' },
            { 'id': 'w2', 'value': 2, 'name': '愿意担任小组组长／纪律委员／财务委员（约3小时／月）' },
            { 'id': 'w3', 'value': 3, 'name': '愿意将来担任董事会岗位（约10小时／月）' },
            { 'id': 'w4', 'value': 4, 'name': '时间不好确定，到时再说' }
          ],
          'regName': 'checkIsEmpty'
        }
      }
      this.initFormData()
    },

    initFormData () {
      let formConfig = this.formConfig ?? {}
      let formData = {}

      // 初始化基本信息
      if (formConfig) {
        Object.keys(formConfig).forEach(item => {
          if (formConfig[item].key === 'gender') {
            formConfig[item].labels.forEach(label => {
              if (label.checked) {
                formData[item] = label.value
              }
            })
          } else if (formConfig[item].type === 'checkbox') {
            formData[item] = []
          } else {
            formData[item] = ''
          }
        })
      }

      // 设置默认值
      formData['country'] = ''
      formData['province'] = ''
      formData['city'] = ''
      formData['willingness_to_participate'] = [1, 2]

      this.formData = formData
    },

    submit () {
      let formConfig = this.formConfig ?? {}

      // 验证基本信息
      if (formConfig) {
        for (let key in formConfig) {
          if (formConfig[key].required) {
            this.blurItem(formConfig[key])
          }
        }
      }

      // 验证城市信息
      if (!Number.isNaN(parseInt(this.formData['country'])) && !Number.isNaN(parseInt(this.formData['province'])) && !Number.isNaN(parseInt(this.formData['city']))) {
        this.regCity = true
      } else {
        this.regCity = false
        utils.toast('您填写的表单内容部分有误，请修改！')
        return
      }

      // 验证手机号组件
      let phoneCheck = this.$refs['account'].check()
      if (!phoneCheck) {
        utils.toast('您填写的表单内容部分有误，请修改！')
        return
      }

      // 验证所有字段
      for (let key in this.warn) {
        if (this.warn[key] === false) {
          utils.toast('您填写的表单内容部分有误，请修改！')
          return
        }
      }

      // 合并所有数据
      const combinedData = {
        ...this.formData,
        ...this.$refs['account'].data()
      }

      // 提交数据
      this.$emit('submit', combinedData)
    },

    blurItem (item) {
      this.$refs[item.key][0].blurFn(item, this.formData)
    },

    focusItem (item) {
      this.$refs[item.key][0].focused = true
    },

    focusInput (item) {
      // 为radio和checkbox等输入组件提供focus处理
    },

    getValue (data) {
      if (data.key === 'focus_areas_tags') {
        this.formData[data.key] = { '1': data.value.map(item => Number(item.id)) }
      } else if (data.key === 'referrers') {
        this.formData[data.key] = data.value.length > 0 ? data.value[0].name : ''
      } else {
        this.formData[data.key] = data.value
      }
    },

    /**
     * 存储已经符合规格的input的键值集合
     */
    setOKList (item) {
      if (item.warning.valid) {
        this.warn[item.key] = true
      } else {
        this.warn[item.key] = false
      }
    },

    SearchTags (value) {
      if (!value.trim()) return
      service.getTags({ 'name': value.trim() })
        .then(data => {
          this.tagTypes = []
          if (data.length) {
            data.forEach(item => {
              item.name = item.tag_name
            })
            this.tagTypes = data
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },

    SearchReferer (value) {
      if (!value.trim()) return
      service.getReferer({ referrers: value })
        .then(data => {
          if (data.length === 0) {
            this.refererArr = []
            return
          }
          this.refererArr = data
        })
        .catch((e) => {
          console.log(e)
        })
    },

    /**
     * set city
     */
    setRegCity (v) {
      this.regCity = v
    },

    maskCompanyName (companyName) {
      if (!companyName) return ''
      const suffixes = ['有限公司', '有限责任公司']
      let mainName = companyName
      let suffix = ''
      suffixes.forEach(s => {
        if (companyName.endsWith(s)) {
          mainName = companyName.slice(0, -s.length)
          suffix = s
        }
      })
      if (mainName.length <= 2) {
        return companyName
      }
      const firstChar = mainName.charAt(0)
      const lastChar = mainName.charAt(mainName.length - 1)
      const middleStars = '*'.repeat(mainName.length - 2)

      return firstChar + middleStars + lastChar + suffix
    },

    formatName (item) {
      if (item.company) {
        return `${item.name} ${this.maskCompanyName(item.company)}`
      }
      return item.name
    },

    /**
     * 限制字数
     * @param {String} v 用户输入字数
     * @param {String} key 键值
     * @param {Number} number 限定字数
     */
    limitNumber (v, key, number) {
      if (v.length > number) {
        this.formData[key] = this.formData[key].slice(0, number)
        this.remainNumber[key] = 0
      } else {
        this.remainNumber[key] = number - v.length
      }
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
    'sameWithPhone': function (n) {
      if (n) {
        if (!this.warn['phone']) return
        this.wechat = this.formData['phone']
        this.formData['wechat'] = this.formData['phone']
      } else {
        this.wechat = ''
        this.formData['wechat'] = ''
      }
    },

    // 基本信息字数限制
    'formData.name': {
      handler: function (n) {
        if (n && n.length > 20) {
          this.formData['name'] = this.formData['name'].slice(0, 20)
        }
      }
    },
    'formData.email': {
      handler: function (n) {
        if (n && n.length > 50) {
          this.formData['email'] = this.formData['email'].slice(0, 50)
        }
      }
    },
    'formData.wechat': {
      handler: function (n) {
        if (n && n.length > 50) {
          this.formData['wechat'] = this.formData['wechat'].slice(0, 50)
        }
      }
    },
    'formData.referrers': {
      handler: function (n) {
        if (n && n.length > 60) {
          this.formData['referrers'] = this.formData['referrers'].slice(0, 60)
        }
      }
    },

    // 详细信息字数限制
    'formData.company': {
      handler: function (n) {
        if (n && n.length > 50) {
          this.formData['company'] = this.formData['company'].slice(0, 50)
        }
      }
    },
    'formData.company_remark': {
      handler: function (n) {
        if (n && n.length > 500) {
          this.formData['company_remark'] = this.formData['company_remark'].slice(0, 500)
        }
      }
    },
    'formData.work_experience': {
      handler: function (n) {
        if (n) this.limitNumber(n, 'work_experience', 1000)
      }
    },
    'formData.achievements': {
      handler: function (n) {
        if (n) this.limitNumber(n, 'achievements', 1000)
      }
    },
    'formData.study_experience': {
      handler: function (n) {
        if (n) this.limitNumber(n, 'study_experience', 1000)
      }
    },
    'formData.support_resource': {
      handler: function (n) {
        if (n) this.limitNumber(n, 'support_resource', 1000)
      }
    },
    'formData.want_resource': {
      handler: function (n) {
        if (n) this.limitNumber(n, 'want_resource', 1000)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../../style/bulma/app.sass'

.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to
  opacity: 0

.section-title
  margin: 40px 0 20px 0
  padding: 20px 0
  border-top: 2px solid #f0f0f0
  h3
    font-size: 18px
    font-weight: 700
    color: #353535
    margin: 0
    +mobile
      font-size: 16px

input
  width: 100%
  &::-webkit-input-placeholder
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder
    color: #bbbec4
    font-size: 12px

.wechat-extra
  margin-right: 15px
  label
    width: 200px
    cursor: pointer
    input
      width: auto
      margin-right: 10px

.form-all
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  +mobile
    margin: 0
  .win
    width: 100%
    position: relative
    .form
      background-color: #fff
      .form-main
        .field-gender
          display: flex
          +mobile
            display: block
          .tgo-birthday
            margin-left: 96px
            +mobile
              margin-left: 0
        .job-title-content
          span
            display: block
            font-size: 14px
            color: #353535
            padding: 0 0 8px 48px
            line-height: 1
          .jtc-wrap
            width: 60%
          +mobile
            span
              padding-left: 0
            .jtc-wrap
              width: auto
        .company-scale
          display: flex
          justify-content: space-between
          +mobile
            display: block
          .scale
            flex-grow: 1
          .remark
            flex-grow: 1
            margin-left: 15px
            margin-top: 44px
            +mobile
              margin-left: 0
              margin-top: 12px
        .submit
          display: flex
          justify-content: center
          margin-top: 40px
          .input
            display: flex
            justify-content: center
            width: 250px
            height: 50px
            border: 1px solid #D7B375
            color: $primary3
            font-size: 16px
            text-align: center
            outline: none
            margin: 0 auto
            cursor: pointer
            align-items: center

.textarea-input
  resize: none
  outline: none
  width: 100%
  height: 80px
  border: none
  font-size: 14px
  &::-webkit-input-placeholder
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder
    color: #bbbec4
    font-size: 12px
  &.work-experience-input
    height: 200px
  &.achievements-input
    height: 200px
  &.study-experience-input
    height: 200px

.input-extra
  font-size: 14px
  color: #bbbec4

.subTitle
  margin: -15px 0 12px 14px
  font-size: 14px
  color: #888

</style>
